import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { EmptyStateProps } from './types';

function EmptyState({ title, description = '', button }: EmptyStateProps) {
  return (
    <Stack
      width="100%"
      direction="column"
      justifyContent="center"
      alignItems="center"
      gap={1}
      data-cy="empty-state"
      height={250}
      // Increase zIndex to make contents clickable
      zIndex={1}
    >
      <Typography variant="h5">{title}</Typography>
      {description && (
        <Typography
          variant="body1"
          color="secondary"
          textAlign="center"
          sx={{ mb: 2, width: '50%' }}
        >
          {description}
        </Typography>
      )}
      {button}
    </Stack>
  );
}

export default EmptyState;
